import { render, staticRenderFns } from "./ItemNew_VariantValues_List.vue?vue&type=template&id=0af06b6c&"
import script from "./ItemNew_VariantValues_List.vue?vue&type=script&lang=js&"
export * from "./ItemNew_VariantValues_List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports